import HeroV2WithMarkers from 'components/landing-pages-v2/HeroV2WithMarkers';

import CarouselCards from '../../components/landing-pages-v2/CarouselSection/CarouselCards';
import ContactSection from '../../components/landing-pages-v2/ContactSection';
import FAQs from '../../components/landing-pages-v2/FAQs';
import FAQsDisplay from '../../components/landing-pages-v2/FAQsDisplay';
import HeroCard from '../../components/landing-pages-v2/HeroCard';
import HeroV2 from '../../components/landing-pages-v2/HeroV2';
import ImageCard from '../../components/landing-pages-v2/ImageCard';
import LWCHeroCard from '../../components/landing-pages-v2/LWCHeroCard';
import LWCImageCard from '../../components/landing-pages-v2/LWCImageCard';
import LWCTextSection from '../../components/landing-pages-v2/LWCTextSection';
import MapBackgroundHero from '../../components/landing-pages-v2/MapBackgroundHero';
import TextSection from '../../components/landing-pages-v2/TextSection';
import Display from '../../components/landing-pages/Display';
import Hero from '../../components/landing-pages/Hero';
import Press from '../../components/landing-pages/Press';
import SellingOptions from '../../components/landing-pages/SellingOptions';
import SocialProofOdometer from '../../components/landing-pages/SocialProofOdometer';
import Steps from '../../components/landing-pages/Steps';
import Testimonials from '../../components/landing-pages/Testimonials';
import VideoHero from '../../components/landing-pages/VideoHero';
import IEntryLookup from './entries';

const landingPageEntryLookup: IEntryLookup = {
  block: {
    lpComponentHero: Hero,
    lpComponentPress: Press,
    lpComponentSteps: Steps,
    lpComponentOdometer: SocialProofOdometer,
    lpComponentTestimonials: Testimonials,
    lpComponentSellingOptions: SellingOptions,
    lpComponentDisplay: Display, // This is using a generic display component
    lpComponentModal: FAQs, // Using generic modal component
    lpComponentVideoHero: VideoHero,
    lpComponentTextSection: TextSection,
    lpComponentHeroCard: HeroCard,
    lpComponentMapBackgroundHero: MapBackgroundHero,
    lpComponentCarouselCards: CarouselCards,
    lpComponentImageCard: ImageCard,
    lpComponentFaqDisplay: FAQsDisplay,
    lpComponentHeroV2: HeroV2,
    lpComponentContactSection: ContactSection,
    lpComponentLwcTextSection: LWCTextSection,
    lpComponentLwcHeroCard: LWCHeroCard,
    lpComponentLwcImageCard: LWCImageCard,
    lpComponentHeroV2WithMarkers: HeroV2WithMarkers,
  },
  inline: {},
};

export default landingPageEntryLookup;
